import React from "react";
import { AiFillFacebook } from 'react-icons/ai';
import { FaVimeoV } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";

function Footer() {
  return (
    <footer className="bg-[#f3f2f8] text-[#0e0e0e] pt-10 pb-6 font-outfit">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Left Info */}
          <div>
            <p className="text-sm text-gray-600 mb-6 font-custom">
              Your T-shirt is more than just fabric — it’s a canvas for your
              ideas, your brand, and your story.
            </p>

            <div className="space-y-3 text-sm text-gray-700">
              <div className="flex items-center gap-2">
            <FaPhone    />
                <span>+1 123 456 7890</span>
              </div>
              <div className="flex items-center gap-2">
              <MdEmail />
                <span>initialglobaltrade@info.com</span>
              </div>
            </div>
          </div>

          {/* Main Links */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-900">Main Links</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="/" className="hover:text-teal-600 transition">Home</a></li>
              <li><a href="/designer" className="hover:text-teal-600 transition">Design Your Own</a></li>
              {/* <li><a href="/" className="hover:text-teal-600 transition">Shop</a></li> */}
              <li><a href="/about" className="hover:text-teal-600 transition">About</a></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-900">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="/Termscondition" className="hover:text-teal-600 transition">Terms & Conditions</a></li>
              <li><a href="/privacy" className="hover:text-teal-600 transition">Privacy Policy</a></li>
              <li><a href="/Return-Policy" className="hover:text-teal-600 transition">Return & Refund Policy</a></li>
              <li><a href="/contact" className="hover:text-teal-600 transition">Contact</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-900">Our Newsletter</h4>
            <form className="flex items-center bg-white rounded-full p-1 shadow-sm">
              <input
                type="email"
                placeholder="Enter your e-mail"
                className="flex-1 px-4 py-2 text-sm text-gray-700 focus:outline-none rounded-full"
              />
              <button
                type="submit"
                className="bg-teal-500 hover:bg-teal-600 text-white rounded-full p-2 transition"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 12h14m-7-7l7 7-7 7"
                  />
                </svg>
              </button>
            </form>

            <h4 className="font-semibold mt-6 mb-2 text-gray-900">We Accept</h4>
            <div className="flex items-center gap-2">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png"
                alt="Mastercard"
                className="h-5"
              />
              {/* <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a4/Visa_2021.svg"
                alt="Visa"
                className="h-5"
              /> */}
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg"
                alt="PayPal"
                className="h-5"
              />
            </div>
          </div>
        </div>

        <hr className="my-8 border-gray-300" />

        {/* Bottom Row */}
        <div className="flex flex-col sm:flex-row items-center justify-between text-sm text-gray-600">
          <div className="flex items-center gap-3 mb-3 sm:mb-0">
            <a href="#" className="bg-white text-gray-600 p-2 rounded-full shadow-sm hover:text-teal-600 transition">
             <AiFillFacebook />
            </a>
            <a href="#" className="bg-white text-gray-600 p-2 rounded-full shadow-sm hover:text-teal-600 transition">
            <FaVimeoV />
            </a>
            <a href="#" className="bg-white text-gray-600 p-2 rounded-full shadow-sm hover:text-teal-600 transition">
             <FaTwitter />
            </a>
          </div>

          <p className="text-center sm:text-left">
            © 2025 Copyright | <span className="font-semibold font-custom">Initial Global Trade</span> | All
            Rights Reserved
          </p>

          <p>
            Powered By{" "}
            <a href="#" className="text-teal-600 hover:underline font-custom">
              Design Verse Studios
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
